import {enabled as smartLabelsEnabled} from '@netx/core-attribute-smart-labels/enablers';
import {i18n} from '@netx/core/i18n';

// Search modes
export let modes = {
	basic: i18n.t('i18n.basic'),
	clip: i18n.t('i18n.constituentClips'),
	'visual:color': i18n.t('i18n.visualColor'),
};

export let systemAttributes = ['file', 'name', 'assetId', 'status'];

////////////////////////////////////////
// Asset searches
////////////////////////////////////////
export let assets = {
	elementTypes: {
		type: 'Select',
		options: [
			{
				label: i18n.t('i18n.keywords'),
				val: 1,
			},
			{
				label: i18n.t('i18n.contents'),
				val: 2,
			},
			{
				label: i18n.t('i18n.attributes'),
				val: 3,
			},
			{
				label: i18n.t('i18n.date'),
				val: 4,
			},
			// {label: "Category", val: 5}, // category search by string is buggy & deprecated
			// category search by catId is the future of awesome
			{
				label: i18n.t('i18n.category'),
				val: 23,
			},
			{
				label: i18n.t('i18n.fileFormat'),
				val: 6,
			},
			{
				label: i18n.t('i18n.fileSize'),
				val: 7,
			},
			{
				label: i18n.t('i18n.advancedRaw'),
				val: 8,
			},
			{
				label: i18n.t('i18n.fileAspect'),
				val: 22,
			},
			{
				label: i18n.t('i18n.checkouts'),
				val: 13,
			},
			{
				label: i18n.t('i18n.savedSearch'),
				val: 24,
			},
			{
				label: i18n.t('i18n.fileFormatFamily'),
				val: 26,
			},
			{
				label: i18n.t('i18n.visual'),
				val: 27,
			},
			{
				label: i18n.t('i18n.user'),
				val: 29,
			},
		],
	},
	elementSubType1s: {
		// Keywords
		1: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.matchAllFragments'),
					val: 4,
				},
				{
					label: i18n.t('i18n.matchAnyFragment'),
					val: 5,
				},
				{
					label: i18n.t('i18n.matchExactly'),
					val: 1,
				},
				{
					label: i18n.t('i18n.matchExactlyIncludingDiacriticalMarks'),
					val: 10,
				},
				{
					label: i18n.t('i18n.matchExclude'),
					val: 3,
				},
				{
					label: i18n.t('i18n.matchAllWholeWordsAND'),
					val: 0,
				},
				{
					label: i18n.t('i18n.matchAnyWholeWordsOR'),
					val: 2,
				},
			],
		},
		// Contents
		2: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.matchAllFragments'),
					val: 4,
				},
				{
					label: i18n.t('i18n.matchAnyFragment'),
					val: 5,
				},
				{
					label: i18n.t('i18n.matchExactly'),
					val: 1,
				},
				{
					label: i18n.t('i18n.matchExclude'),
					val: 3,
				},
				{
					label: i18n.t('i18n.matchAllWholeWordsAND'),
					val: 0,
				},
				{
					label: i18n.t('i18n.matchAnyWholeWordsOR'),
					val: 2,
				},
			],
		},
		// Attributes
		3: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.matchAllFragments'),
					val: 4,
				},
				{
					label: i18n.t('i18n.matchAnyFragment'),
					val: 5,
				},
				{
					label: i18n.t('i18n.matchExactly'),
					val: 1,
				},
				{
					label: i18n.t('i18n.matchExclude'),
					val: 3,
				},
				{
					label: i18n.t('i18n.matchAllWholeWordsAND'),
					val: 0,
				},
				{
					label: i18n.t('i18n.matchAnyWholeWordsOR'),
					val: 2,
				},
				{
					label: i18n.t('i18n.matchAnyRange'),
					val: 6,
				},
				// Removed per https://jira.netx.net/browse/DAM-8229
				// Possibly related to attributes of type heirarchical?
				// {label: "Options [OPTS]", val: 7}
				{
					label: i18n.t('i18n.matchValueIsEmpty'),
					val: 11,
				},
				{
					label: i18n.t('i18n.matchValueIsNotEmpty'),
					val: 12,
				},
			],
		},
		// Date
		4: {
			type: 'Select',
			options: [
				// See dateSubTypes1_default
			],
		},
		// Category name is too buggy (5) - use 23
		// File format
		6: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.only'),
					val: 0,
				},
				{
					label: i18n.t('i18n.exclude'),
					val: 1,
				},
			],
		},
		// File size
		7: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.approximately'),
					val: 0,
				},
				{
					label: i18n.t('i18n.greaterThan'),
					val: 1,
				},
				{
					label: i18n.t('i18n.lessThan'),
					val: 2,
				},
				{
					label: i18n.t('i18n.equalTo'),
					val: 3,
				},
			],
		},
		// Advanced(raw)
		8: {},
		// Checkouts
		13: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.all'),
					val: 0,
				},
				{
					label: i18n.t('i18n.specificUser'),
					val: 1,
				},
			],
		},
		// File Aspect
		22: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.orientation'),
					val: 0,
				},
				{
					label: i18n.t('i18n.durationSeconds'),
					val: 1,
				},
				{
					label: i18n.t('i18n.width'),
					val: 2,
				},
				{
					label: i18n.t('i18n.height'),
					val: 3,
				},
			],
		},
		// Category
		23: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.onlyRecursive'),
					val: 0,
				},
				{
					label: i18n.t('i18n.excludeRecursive'),
					val: 1,
				},
				{
					label: i18n.t('i18n.only'),
					val: 2,
				},
				{
					label: i18n.t('i18n.exclude'),
					val: 3,
				},
			],
		},
		// Saved Search
		24: {},
		// File Format Family
		26: {},
		// Visual
		27: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.asset'),
					val: 1,
				},
				{
					label: i18n.t('i18n.color'),
					val: 2,
				},
			],
		},
		// User
		29: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.importedBy'),
					val: 0,
				},
				{
					label: i18n.t('i18n.modifiedBy'),
					val: 1,
				},
			],
		},
	},
	elementSubType2s: {
		// Keywords
		1: {},
		// Contents
		2: {},
		// Attributes
		3: {},
		// Date
		4: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.today'),
					val: 9,
				},
				{
					label: i18n.t('i18n.rangeYesterday'),
					val: 10,
				},
				{
					label: i18n.t('i18n.rangeLastWeek'),
					val: 7,
				},
				{
					label: i18n.t('i18n.rangeLastMonth'),
					val: 8,
				},
				{
					label: i18n.t('i18n.rangeLastThreeMonths'),
					val: 1,
				},
				{
					label: i18n.t('i18n.rangeLastSixMonths'),
					val: 2,
				},
				{
					label: i18n.t('i18n.rangeLastYear'),
					val: 3,
				},
				{
					label: i18n.t('i18n.rangeBefore'),
					val: 4,
				},
				{
					label: i18n.t('i18n.rangeAfter'),
					val: 5,
				},
				{
					label: i18n.t('i18n.rangeInBetween'),
					val: 6,
				},
			],
		},
		// Category name is too buggy (5) - use 23
		// File Format
		6: {},
		// File Size
		7: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.unitBytes'),
					val: 0,
				},
				{
					label: i18n.t('i18n.unitKbytes'),
					val: 1,
				},
				{
					label: i18n.t('i18n.unitMbytes'),
					val: 2,
				},
				{
					label: i18n.t('i18n.unitGbytes'),
					val: 3,
				},
			],
		},
		// Advanced(raw)
		8: {},
		// Checkouts
		13: {},
		// File Aspect - alternate (if elementSubType1s === 0)
		'22-0': {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.equals'),
					val: 3,
				},
			],
		},
		22: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.approximately'),
					val: 0,
				},
				{
					label: i18n.t('i18n.greaterThan'),
					val: 1,
				},
				{
					label: i18n.t('i18n.lessThan'),
					val: 2,
				},
				{
					label: i18n.t('i18n.equals'),
					val: 3,
				},
			],
		},
		// Category
		23: {},
		// Saved Search
		24: {},
		// File Format Family
		26: {},
		// Visual
		27: {},
		// User
		29: {},
	},
	elementValue1s: {
		// Keywords
		1: {
			type: 'Text',
		},
		// Contents
		2: {
			type: 'Text',
		},
		// Attributes
		3: {
			type: 'Text',
		},
		// Attribute match empty
		'3-11': {},
		// Attribute match not empty
		'3-12': {},
		// Date
		4: {
			type: 'Date',
		},
		// Category name is too buggy (5) - use 23
		// File Format
		6: {
			type: 'Select',
			data: 'FileType',
		},
		// File Size
		7: {
			type: 'Text',
		},
		// Advanced(raw)
		8: {
			type: 'Text',
		},
		// Checkouts
		13: {
			type: 'Select',
			data: 'User',
		},
		// File Aspect - alternate (if elementSubType1s === 0)
		'22-0': {
			type: 'Select',
			data: 'Orientation',
		},
		// File Aspect
		22: {
			type: 'Text',
		},
		// Category
		23: {
			type: 'Text',
		},
		// Saved Search
		24: {
			type: 'Text',
		},
		// File Format Family
		26: {
			type: 'Select',
			data: 'FileFormatFamily',
		},
		// Visual
		27: {
			type: 'Visual',
		},
		// User
		29: {
			type: 'Select',
			data: 'User',
		},
	},
	elementValue2s: {
		// Keywords
		1: {},
		// Contents
		2: {},
		// Attributes
		3: {
			type: 'Select',
			options: [],
		},
		// Date
		4: {},
		// Category name is too buggy (5) - use 23
		// File Format
		6: {},
		// File Size
		7: {},
		// Advanced(raw)
		8: {},
		// Checkouts
		13: {},
		// File Aspect
		22: {},
		// Category
		23: {},
		// Saved Search
		24: {},
		// File Format Family
		26: {},
		// Visual
		27: {},
		// User
		29: {},
	},
	elementValue3s: {
		// Keywords
		1: {},
		// Contents
		2: {},
		// Attributes
		3: {},
		// Date
		4: {
			type: 'Date',
		},
		// Category name is too buggy (5) - use 23
		// File Format
		6: {},
		// File Size
		7: {},
		// Advanced(raw)
		8: {},
		// Checkouts
		13: {},
		// File Aspect
		22: {},
		// Category
		23: {},
		// Saved Search
		24: {},
		// File Format Family
		26: {},
		// Visual
		27: {},
		// User
		29: {},
	},
	sortFields: {
		// Expiration date gets inserted in search controller init if expiration is enabled
		// TODO: Make sort fields a collection that can handle user prefs and events - also, then we can have compartors and sort these things in the DOM
		// this list gets concated with user defined attribute names and things get out of order
		// https://jira.netx.net/browse/DAM-9364
		// expirationDate   : i18n.t('i18n.expirationDate'),
		file: i18n.t('i18n.file'),
		name: i18n.t('i18n.name'),
		assetId: i18n.t('i18n.assetId'),
		fileFormatFamily: i18n.t('i18n.fileFormatFamily'),
		fileSize2: i18n.t('i18n.fileSize'),
		filetypelabel: i18n.t('i18n.fileType'),
		height: i18n.t('i18n.height'),
		importDate: i18n.t('i18n.importDate'),
		moddate: i18n.t('i18n.modDate'),
		creationdate: i18n.t('i18n.creationDate'),
		dimensions: i18n.t('i18n.dimensions'),
		relevance: i18n.t('i18n.relevance'),
		width: i18n.t('i18n.width'),
	},
};

// Will be concated with date attributes (on attributes fetch) and applied to assets.elementSubType1s.Date.options
export let dateSubTypes1_default = [
	{
		label: i18n.t('i18n.creationDate'),
		val: 0,
	},
	{
		label: i18n.t('i18n.lastModified'),
		val: 1,
	},
	// Type 2 is for searching date attributes, where value3 is set to the attribute name.
	// Type 2 is only avialable when there are attribute templates of date type (See: Netx.Collections.Attributes)
	{
		label: i18n.t('i18n.importDate'),
		val: 3,
	},
];
////////////////////////////////////////
// !Asset searches
////////////////////////////////////////

////////////////////////////////////////
// Attribute searches
////////////////////////////////////////
export let attributes = {
	elementTypes: {
		type: 'Select',
		options: [
			{
				label: i18n.t('i18n.cart'),
				val: 10,
			},
		],
	},
	elementSubType1s: {
		// Cart
		10: {},
	},
	elementSubType2s: {
		// Cart
		10: {},
	},
	elementValue1s: {
		// Cart
		10: {
			type: 'Text',
		},
	},
	elementValue2s: {
		// Cart
		10: {},
	},
	elementValue3s: {
		// Cart
		10: {},
	},
};
////////////////////////////////////////
// !Attribute searches
////////////////////////////////////////

////////////////////////////////////////
// Clip searches
////////////////////////////////////////
export let clips = {
	elementTypes: {
		type: 'Select',
		options: [
			{
				label: i18n.t('i18n.keywords'),
				val: 101,
			},
			{
				label: i18n.t('i18n.assets'),
				val: 102,
			},
			{
				label: i18n.t('i18n.attributes'),
				val: 101,
			},
		],
	},
	elementSubType1s: {
		// Keywords
		// Attributes
		101: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.matchAllWildcardsAND'),
					val: 4,
				},
				{
					label: i18n.t('i18n.matchAnyWildcardsOR'),
					val: 5,
				},
				{
					label: i18n.t('i18n.matchExactly'),
					val: 1,
				},
				{
					label: i18n.t('i18n.matchAllWords'),
					val: 0,
				},
				{
					label: i18n.t('i18n.matchAnyWholeWordsOR'),
					val: 2,
				},
				{
					label: i18n.t('i18n.matchEmpty'),
					val: 6,
				},
				{
					label: i18n.t('i18n.matchAnyRange'),
					val: 9,
				},
			],
		},
		// Assets
		102: {},
	},
	elementSubType2s: {
		// Keywords
		// Attributes
		101: {},
		// Assets
		102: {},
	},
	elementValue1s: {
		// Keywords
		// Attributes
		101: {
			type: 'Text',
		},
		// Assets
		102: {
			type: 'Text',
		},
	},
	elementValue3s: {
		// Keywords
		// Attributes
		101: {},
		// Assets
		102: {},
	},
	sortFields: {
		startTime: i18n.t('i18n.startTime'),
		endTime: i18n.t('i18n.endTime'),
		title: i18n.t('i18n.title'),
	},
};
////////////////////////////////////////
// !Clip searches
////////////////////////////////////////

////////////////////////////////////////
// Facets
////////////////////////////////////////
// Search types facets support
export let facetSupports = [
	1, // Keyword
	2, // Contents
	3, // Metadata
	4, // Date
	5, // Category name
	6, // File format
	7, // File size
	8, // Advanced raw
	10, // Cart
	13, // Checkouts
	14, // Thesaurus - no longer a thing really but still there
	22, // File aspect
	23, // Category id
	24, // Saved search
	26, // File format family
	27, // Visual search
	28, // Active templates
	200, // Attribute history
];

// Translation/readability
export let systemFacetOptions = {
	'creationDate.older': i18n.t('i18n.older'),
	'creationDate.pastMonth': i18n.t('i18n.pastMonth'),
	'creationDate.pastWeek': i18n.t('i18n.pastWeek'),
	'creationDate.pastYear': i18n.t('i18n.pastYear'),
	'creationDate.today': i18n.t('i18n.today'),
	'fileSize.extraLarge': i18n.t('i18n.extraLarge'),
	'fileSize.large': i18n.t('i18n.large'),
	'fileSize.medium': i18n.t('i18n.medium'),
	'fileSize.small': i18n.t('i18n.small'),
	'fileSize.tiny': i18n.t('i18n.tiny'),
	'importDate.older': i18n.t('i18n.older'),
	'importDate.pastMonth': i18n.t('i18n.pastMonth'),
	'importDate.pastYear': i18n.t('i18n.pastYear'),
	'importDate.pastWeek': i18n.t('i18n.pastWeek'),
	'importDate.today': i18n.t('i18n.today'),
	'modificationDate.older': i18n.t('i18n.older'),
	'modificationDate.pastMonth': i18n.t('i18n.pastMonth'),
	'modificationDate.pastWeek': i18n.t('i18n.pastWeek'),
	'modificationDate.pastYear': i18n.t('i18n.pastYear'),
	'modificationDate.today': i18n.t('i18n.today'),
};

// These are system provided facets
export let systemFacets = {
	creationDate: i18n.t('i18n.created'),
	fileFormatFamily: i18n.t('i18n.type'),
	fileSize: i18n.t('i18n.size'),
	fileType: i18n.t('i18n.extension'),
	folder: i18n.t('i18n.folder'),
	category: i18n.t('i18n.category'),
	importDate: i18n.t('i18n.imported'),
	modificationDate: i18n.t('i18n.modified'),
};
////////////////////////////////////////
// !Facets
////////////////////////////////////////

// Populated by the search module when it initializes.
export let fileFormatFamilies = {};

// Populated by the search module when it initializes.
export let fileTypes = {};

// For File Aspect of Orientation
export let orientationTypes = {
	1: i18n.t('i18n.portrait'),
	2: i18n.t('i18n.landscape'),
};

// For saved search notification
export let notificationTypes = {
	0: i18n.t('i18n.none'),
	1: i18n.t('i18n.weekly'),
	2: i18n.t('i18n.daily'),
	3: i18n.t('i18n.immediately'),
};

//
export let permissionTypes = {
	MANAGE: 'manage',
	NONE: 'none',
	OWN: 'own',
	READ: 'read',
	WRITE: 'write',
};

// Properties that can be updated manually
export let searchProperties = [
	'sortField',
	'sortOrder',
	'matchCriteria',
	'saveSearch',
	'notifyType',
	'ignoreStat',
	'startPosition',
	// 'maxItems' // hands off maxItems!  use chunkSize/pageSize instead.
];

// DEVNOTE:
// All of these 'options' objects are awkward to use in any context other than when directly generating form select elements.
// (If they used the key "value" instead of "val", we could at least use our LVB utitities to parse them.)
//
// We need objects that simply define our constants, so we can use them everywhere.
// For instance, when defining a search in code, we want to use these symbolic constants instead of inline integers,
// so our code is easier to read.

// Therefore:
// Here's a function to parse one of these label/val arrays into a normal object:
export let normalize = (options) => {
	if (options == null) return undefined;

	const normalObj = {};
	_.each(options, (lvobj) => {
		normalObj[lvobj.label] = lvobj.val;
	});
	return normalObj;
};
// Using that, we can attach meaningful symbolic names to all of the search-rule integer values we use:

const normal = (assets.normal = {}); // "The word 'normal' here means 'as done elsewhere (mostly)'.
normal.types = normalize(assets.elementTypes.options);

_.each(
	['subType1s', 'subType2s', 'value1s', 'value2s', 'value3s'],
	(things) => {
		// the keys we'll use in the 'normal' object
		const ruleComponent = assets[`element${_.ucfirst(things)}`]; // 'elementSubType1', 'elementValue3', etc.
		normal[things] = {};
		_.each(_.keys(ruleComponent), (searchType) => {
			normal[things][searchType] = normalize(ruleComponent[searchType].options);
		});
	},
);

// TODO: The cms module in portal that is grabbing this file too early (prior to having user prefs)
// we need to clean that up at some point as we should not be grabbing things from other modules
// until prefs are returned form the server (for a variety of reasons)
//
// For anything that waits for prefs before loading this file
if (smartLabelsEnabled()) {
	assets.sortFields['smart labels'] = i18n.t('i18n.smartLabels');
}
// For portal
dispatcher.once('app:user:prefs:ready', () => {
	if (smartLabelsEnabled()) {
		assets.sortFields['smart labels'] = i18n.t('i18n.smartLabels');
	}
});

export default {
	assets,
	attributes,
	clips,
	dateSubTypes1_default,
	facetSupports,
	fileFormatFamilies,
	fileTypes,
	modes,
	normal,
	normalize,
	notificationTypes,
	orientationTypes,
	permissionTypes,
	searchProperties,
	systemFacetOptions,
	systemFacets,
};
